<script lang="ts">
    import { getCachedEntries, getDBEntries } from "../../../api"
    import { onChange } from "../../components/formComponents/helper"
    import Input from "../../components/formComponents/Input.svelte"
    import Images from "./Images.svelte"

    export let field: TaskStepField<"usageAmountObjects">,
        value: Disposals[] = []
    if (!Array.isArray(value)) value = []
    let options: Option[] = []
    interface OptionValueStorage extends Disposals {
        active: boolean
    }
    let valueStorage: OptionValueStorage[] = []
    getCachedEntries("option", {
        category: "disposableMaterial",
    }).then((optionObjs) => {
        options = optionObjs
        valueStorage = options.map((option) => {
            let existingValueIndex = (value || []).findIndex((value) => value.materialId === option.id)
            if (existingValueIndex !== -1) {
                return {
                    ...value[existingValueIndex],
                    active: true,
                }
            }
            return {
                materialId: option.id,
                amount: null,
                materialImageIds: [],
                length: null,
                width: null,
                active: false,
            }
        })
    })

    $: valueStorage = valueStorage.map((val) => {
        return {
            ...val,
            active: !!val.amount,
        }
    })

    $: {
        const filteredValue = valueStorage.length
            ? valueStorage.filter((val) => val.active || val.materialImageIds?.length)
            : value
        if (JSON.stringify(filteredValue) !== JSON.stringify(value)) {
            value = filteredValue
        }
    }
</script>

<div class="disposalsWrapper form">
    <h2>Entsorgungsmengen</h2>
    <ul class="objects">
        {#each valueStorage as val, i}
            <li class="grid">
                {#if options.find((o) => o.id == val.materialId).additionalInfos.unit == "kgOnm2"}
                    <div class="col-6 flex">
                        <div class="col-3">
                            <Input
                                id="{val.materialId}"
                                bind:value="{valueStorage[i].amount}"
                                type="checkboxInputNumber"
                                placeholder="{options.find((o) => o.id == val.materialId).name}"
                                onChange="{onChange}"
                                unit="kg"
                            />
                        </div>
                        <span>auf</span>
                        <div class="col-3">
                            <Input
                                id="{val.materialId}-length"
                                bind:value="{valueStorage[i].length}"
                                type="number"
                                placeholder="Länge"
                                onChange="{onChange}"
                                unit="m"
                            />
                        </div>
                        <span>x</span>
                        <div class="col-3">
                            <Input
                                id="{val.materialId}-width"
                                bind:value="{valueStorage[i].width}"
                                type="number"
                                placeholder="Breite"
                                onChange="{onChange}"
                                unit="m"
                            />
                        </div>
                    </div>
                {:else}
                    <div class="col-6">
                        <Input
                            id="{val.materialId}"
                            bind:value="{valueStorage[i].amount}"
                            type="checkboxInputNumber"
                            placeholder="{options.find((o) => o.id == val.materialId).name}"
                            onChange="{onChange}"
                            unit="{options.find((o) => o.id == val.materialId).additionalInfos.unit.toLowerCase()}"
                        />
                    </div>
                {/if}
                <div class="col-6">
                    <Images
                        bind:value="{valueStorage[i].materialImageIds}"
                        field="{{
                            widget: 'image[]',
                        }}"
                    />
                </div>
            </li>
        {/each}
    </ul>
</div>

<style lang="less">
    @import "../../../../assets/variables.less";
    .disposalsWrapper {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        .objects {
            display: flex;
            flex-direction: column;
            gap: 0.6rem;
            .flex {
                display: flex;
                gap: 0.5rem;
                flex-wrap: wrap;
                height: fit-content;
                align-items: center;
                color: var(--text-100);
                div {
                    flex: 1;
                }
                span {
                    width: fit-content;
                }

                @media @mobile {
                    display: grid;
                    grid-template-columns: 5fr 1fr 4fr 1fr;
                    & > * {
                        display: flex;
                        justify-content: center;
                        width: 100% !important;
                        overflow: hidden;
                        &:first-child {
                            grid-column: span 3;
                            grid-row: 1 / 2;
                        }
                        // make 2nd and 4 take 4 and 3rd 1
                        &:nth-child(2) {
                            grid-column: 4 / 5;
                            grid-row: 1 / 2;
                        }
                        &:nth-child(3) {
                            grid-column: 1 / 2;
                            grid-row: 2 / 3;
                        }
                        &:nth-child(4) {
                            grid-column: 2 / 3;
                            grid-row: 2 / 3;
                        }
                        &:nth-child(5) {
                            grid-column: 3 / 5;
                            grid-row: 2 / 3;
                        }
                    }
                }
            }

            @media @mobile {
                gap: 0px;
                li {
                    display: flex;
                    flex-direction: column;
                    padding: 0.6rem 0px;
                    border-bottom: 1px dashed var(--grey-200);
                    &:first-child {
                        padding-top: 0px;
                    }
                    &:last-child {
                        border-bottom: none;
                        padding-bottom: 0px;
                    }
                }
            }
        }
    }
</style>
